import { statics } from 'modules/common';
import { EditableQBooksCustomer, EditableQBooksVendor } from 'pages/requestForm/data/qbooks/EditableQBooksCounterparty';
import { GetOcr } from 'shared/data/webApp/v2';

export const getDefaultValues = (
    initContact: EditableQBooksCustomer | EditableQBooksVendor,
    companyCurrency: string,
    ocrData?: GetOcr['response']
) => {
    const defaultCurrency = statics.currency.currencyReferences.find((currency) => currency.id === companyCurrency);

    const processedInitialContact = {
        ...initContact,
        displayName: ocrData?.document?.vendor?.name || initContact.displayName,
        currencyId: ocrData?.document?.currencyCode || defaultCurrency?.id,
        billingAddress: {
            ...initContact.billingAddress,
            street: ocrData?.document?.vendor?.address?.street || initContact.billingAddress.street,
            city: ocrData?.document?.vendor?.address?.city || initContact.billingAddress.city,
            state: ocrData?.document?.vendor?.address?.region || initContact.billingAddress.state,
            country: ocrData?.document?.vendor?.address?.country || initContact.billingAddress.country,
            postalCode: ocrData?.document?.vendor?.address?.postalCode || initContact.billingAddress.postalCode,
        },
    };

    return processedInitialContact;
};
